import { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from 'react'
import { ClassValue } from 'clsx'
import { cn } from 'shared/styles'
import { BUTTON_SIZE_MAPS, BUTTON_TYPE_MAPS } from './buttonMaps'

type Props = {
  htmlType?: 'button' | 'submit' | 'reset'
  size?: keyof typeof BUTTON_SIZE_MAPS
  buttonType?: keyof typeof BUTTON_TYPE_MAPS
  icon?: ReactNode
  customStyles?: ClassValue
} & DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

export function Button({
  children,
  htmlType = 'button',
  size = 'MEDIUM',
  buttonType = 'PRIMARY',
  icon,
  customStyles,
  ...props
}: Props) {
  return (
    <button
      {...props}
      type={htmlType}
      className={cn(
        'whitespace-no-wrap flex items-center justify-center rounded-md transition',
        BUTTON_TYPE_MAPS[buttonType],
        BUTTON_SIZE_MAPS[size],
        customStyles,
      )}
    >
      {icon}
      {children}
    </button>
  )
}
